(() => {
  class DetailsDisclosure extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.mainDetailsToggle = this.querySelector('details');
      if (!this.mainDetailsToggle) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('keyup', event => this.onKeyUp(event), { signal });
      document.addEventListener('click', event => this.onFocusOut(event), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    onKeyUp(event) {
      if ((event.key || event.code || '').toUpperCase() !== 'ESCAPE') return;
      const details = event.target.closest?.('details[open]');
      if (!details || !this.contains(details)) return;
      const summary = details.querySelector('summary');
      details.removeAttribute('open');
      summary?.setAttribute('aria-expanded', 'false');
      summary?.focus();
    }

    onFocusOut(event) {
      if (!event.composedPath().includes(this.mainDetailsToggle)) this.close();
    }

    close() {
      this.mainDetailsToggle?.removeAttribute('open');
      this.mainDetailsToggle?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }
  }

  class DetailsDisclosureFilter extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.mainDetailsToggle = this.querySelector('details');
      if (!this.mainDetailsToggle) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      // In the current Liquid, the close link is a sibling of facets__wrapper.
      this.content = this.mainDetailsToggle.querySelector('.close_filter_element');
      this.addEventListener('keyup', event => this.onKeyUp(event), { signal });
      this.content?.addEventListener('focusout', () => this.onFocusOut(), { signal });
      this.content?.addEventListener('click', event => {
        event.preventDefault();
        this.close();
        this.mainDetailsToggle.querySelector('summary')?.focus();
      }, { signal });
      this.mainDetailsToggle.addEventListener('toggle', () => {
        this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
        if (!this.mainDetailsToggle.open) this.clearActiveState();
      }, { signal });
    }

    disconnectedCallback() {
      clearTimeout(this.focusOutTimer);
      this.controller?.abort();
      this.controller = null;
    }

    onKeyUp(event) {
      if ((event.key || event.code || '').toUpperCase() !== 'ESCAPE') return;
      const details = event.target.closest?.('details[open]');
      if (!details || !this.contains(details)) return;
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      summary?.setAttribute('aria-expanded', 'false');
      summary?.focus();
      if (details === this.mainDetailsToggle) this.clearActiveState();
    }

    onFocusOut() {
      clearTimeout(this.focusOutTimer);
      this.focusOutTimer = setTimeout(() => {
        // Moving from Close to Apply must not close and then reopen the filter.
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    clearActiveState() {
      this.querySelectorAll('.facets__wrapper, .facets__wrapper-js, .facets__button-show')
        .forEach(element => element.classList.remove('active'));
      const mask = this.closest('facet-filters-form')?.querySelector('.facets-mask') || document.querySelector('.facets-mask');
      mask?.classList.remove('active');
    }

    close() {
      this.mainDetailsToggle?.removeAttribute('open');
      this.mainDetailsToggle?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      this.clearActiveState();
    }
  }

  if (!customElements.get('details-disclosure')) customElements.define('details-disclosure', DetailsDisclosure);
  if (!customElements.get('details-disclosure-filter')) customElements.define('details-disclosure-filter', DetailsDisclosureFilter);
})();